<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px"><path d="M85-87.5v-788h790v631H242L85-87.5Z"/></svg>
</template>